import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
    transform(size: number | string): string {
        if (!size || (typeof size === 'number' && size < 0)) {
            return '0 B';
        }

        const bytes = typeof size === 'string' ? parseInt(size, 10) : size;

        if (isNaN(bytes)) {
            return '0 B';
        }

        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        const index = Math.floor(Math.log(bytes) / Math.log(1024));
        const value = bytes / Math.pow(1024, index);

        return `${parseFloat(value.toFixed(2))} ${units[index]}`;
    }
}
